// @flow

import React from 'react';
import { Icon, IconClose, IconChatLine } from '../../../base/icons';
import { _connect } from './ChatHeader';

function RPC_Header({ onCancel, className }: Props) {
    return (
        <div
            className = { className || 'chat-dialog-header' }>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Icon
                    onClick = { onCancel }
                    src = { IconChatLine } />
                <span>&nbsp;&nbsp;Chat</span>
            </div>
            <Icon
                onClick = { onCancel }
                src = { IconClose } />
        </div>
    );
}

export default _connect(RPC_Header);
